import store from "@/services/store";

function redondeaValue(r, x, operation) {
    var xx = Math.floor(x / r);
    if (xx != x / r) {
        if (operation === 1) {
            xx++;
        }
        xx = xx * r;
        xx = xx - x
    } else {
        if (operation === 1) {
            xx = r;
        } else {
            xx = -r;
        }
    }

    return xx;
}

function aporteValue() {
    let cesantias = (store.state.crudStore.dataForm.afiliado_liquidacion.info_afiliacion.salario + store.state.crudStore.dataForm.afiliado_liquidacion.info_liquidacion.transporte) * 1 / 360
    let intereses = (cesantias * 1 * 0.12) / 360
    let primerprima = cesantias
    let segundaprima = 0
    let vacaciones = store.state.crudStore.dataForm.afiliado_liquidacion.info_afiliacion.salario * 1 / 720

    return { cesantias: cesantias, intereses: intereses, primerprima: primerprima, segundaprima: segundaprima, vacaciones: vacaciones }

}
export default {
    data() {
        return {
            devengadosItems: [{
                    thead: { th: "concepto" },
                    tbody: { td: ["concepto"] }
                },
                {
                    thead: { th: "valor", style: "width: 100px" },
                    tbody: { td: ["valor"] }
                },
            ],
            devengadosInits: [
                { id: null, id_info_liquidacion: null, concepto: 'Cesantías', valor: aporteValue().cesantias, predeterminado: 'cesantias' },
                { id: null, id_info_liquidacion: null, concepto: 'Intereses sobre cesantías', valor: aporteValue().intereses, predeterminado: 'intereses' },
                { id: null, id_info_liquidacion: null, concepto: 'Prima primer semestre', valor: aporteValue().primerprima, predeterminado: 'primerprima' },
                { id: null, id_info_liquidacion: null, concepto: 'Prima segundo semestre', valor: aporteValue().segundaprima, predeterminado: 'segundaprima' },
                { id: null, id_info_liquidacion: null, concepto: 'Vacaciones', valor: aporteValue().vacaciones, predeterminado: 'vacaciones' },
            ],
            deducidosItems: [{
                    thead: { th: "concepto" },
                    tbody: { td: ["concepto"] }
                },
                {
                    thead: { th: "valor", style: "width: 100px" },
                    tbody: { td: ["valor"] }
                },
            ],
            tableGBoptions: {
                modals: [{
                    modal: "Anular",
                    icon: "x-circle",
                    title: "Anular Liquidación",
                    variant: 'danger',
                    movil: true
                }, ]
            },

            tableGBSearch: ['info_liquidacion/name', 'info_liquidacion/documento'],

            tableGBItems: [{
                    thead: { th: 'Documento' },
                    tbody: { td: ['lis_documento/name', 'info_liquidacion/documento'] }
                },
                {
                    thead: { th: 'Nombre', sort: null, sortTable: 'info_liquidacion/name' },
                    tbody: { td: ['info_liquidacion/name'] }
                },
                {
                    thead: { th: 'Razon Social' },
                    tbody: { td: ['datos_razon/name'], }
                },
                {
                    thead: { th: 'Desde', },
                    tbody: { td: ['info_liquidacion/fechaini'], }
                },
                {
                    thead: { th: 'Hasta', },
                    tbody: { td: ['info_liquidacion/fechafin'], }
                },
                {
                    thead: { th: 'Valor', },
                    tbody: { td: ['info_liquidacion/valor'], }
                },
                {
                    thead: { th: 'Imprimir', },
                    tbody: { td: ['info_liquidacion/id'], link: '/api/pdf/liquidacion' }
                },
            ],
        }
    },
}